import { render, staticRenderFns } from "./importPlan.vue?vue&type=template&id=60104834&scoped=true&"
import script from "./importPlan.vue?vue&type=script&lang=js&"
export * from "./importPlan.vue?vue&type=script&lang=js&"
import style0 from "./importPlan.vue?vue&type=style&index=0&id=60104834&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60104834",
  null
  
)

export default component.exports